var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hover--text",class:[
        _vm.classes,
        _vm.hoverClass,
        'd-inline-block',
        _vm.$vuetify.theme.dark ? 'dark--hover' : 'white--hover' ],on:{"mousemove":function($event){return _vm.textHover($event, false, _vm.mobile)},"mouseover":function($event){_vm.onHover($event);
        _vm.showCursor(_vm.text, _vm.link, _vm.mobile);},"mouseout":function($event){_vm.onHover($event);
        _vm.hideCursor(_vm.mobile);
        _vm.textHover($event, true, _vm.mobile);},"click":function($event){return _vm.$emit('click', $event)}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }